import { upload } from "@/apis/common";
import { useConfigContext } from "@/app";
import { ImageUploadItem, ImageUploader, Toast,Image } from "antd-mobile";
import classNames from "classnames";
import isEqual from "lodash/isEqual";
import { useEffect, useMemo, useRef, useState } from "react";
import { v4 } from "uuid";
import styles from "./styles.module.scss";

export type UploadImgValue = ImageUploadItem | undefined;
type UploadImgProps = {
  value?: UploadImgValue;
  onChange?: (val: UploadImgValue) => void;
  getUploading?: (loading: boolean) => void;
  children?: React.ReactNode;
  type?: string;
  className?: string;
};

type h5pType = {
  file?: File;
  url?: string;
  key?: string | number;
  visible?: boolean;
};

export const UploadImg = (props: UploadImgProps) => {
  const {getSourcePath} = useConfigContext();
  const [uploading, setUploading] = useState<boolean>(false);
  const imgContentRef = useRef<string>("");
  const [value, setValue] = useState<UploadImgValue>();
  const [_id] = useState<string>(() => {
    return v4();
  });

  const [h5pData, setH5pData] = useState<h5pType>();

  const onUpload = async (file: File): Promise<ImageUploadItem> => {
    const formData = new FormData();
    formData.append("imgFile", file);
    formData.append("type", props.type || "order");
    const result = await upload(formData);
    Toast.show(result.msg);
    setUploading(false);
    if (result && result.ok && result.data) {
      const url = result.data?.name;
      setUploading(false);
      return {
        // url:  "",
        // key:  "",
        url: getSourcePath(url) || "",
        key: url || "",
      };
    } else {
      Toast.show({
        content: "上传附件失败",
      });
      imgContentRef.current = "";
      return {
        url: "",
        key: "",
      };
    }
  };

  const beforeUpload = (
    file: File,
    files: File[]
  ): File | Promise<File | null> | null => {
    return new Promise<File | null>((resolve, reject) => {
      setUploading(true);

      return resolve(file);
    });
  };

  const onFileChange = (files?: ImageUploadItem[]) => {
    let _val;
    
    console.log('filesss===',files);
    
    if (Array.isArray(files) && files[0] && files[0].url) {
      const file = files[0];
      console.log('url222==',files[0].url);
      _val = { ...file };
      setH5pData({url:files[0].url||"",key:files[0].key||"",visible:true})
    }
    
    imgContentRef.current = "";
    setValue(_val);
    typeof props.onChange === "function" && props.onChange(_val);
  };
  useEffect(() => {
    typeof props.getUploading === "function" && props.getUploading(uploading);
  }, [uploading, props]);
  useEffect(() => {
    if (isEqual(props.value, value)) {
      setValue(props.value);
    }
  }, [props.value]);

  // const _value = useMemo(() => {
  //   console.log('value==',value);
    
  //   if (value?.url) {
  //     return [{ ...value, url: getSourcePath(value.url) }];
  //   } else {
  //     return [];
  //   }
  // }, [value]);

  const h5pUpload = ()=>{
    window.h5p.uploadImage((blob, name, type, filePath) => {
      const files = new File([blob],name||"",{ type: type });
      onUpload(files).then(res=>{
        onFileChange([{...files,url:res.url||"",key:res.key||""}]);
        setH5pData({url:res.url||"",key:res.key||"",visible:true})
      });
    })
  }
  
  return (
    <div className={styles.uploadBox}>
        {window.plus ? (<div className={styles.h5pUpload} onClick={h5pUpload}>
          {h5pData?.visible ?  <Image
            fit="contain"
            src={h5pData?.url}
          />: null}
        </div>):null }
        <ImageUploader
         upload={onUpload}
         beforeUpload={beforeUpload}
         multiple={false}
         preview={false}
         capture={false}
         disableUpload={window.plus ? true:false}
         maxCount={1}
        //  value={_value}
         className={classNames(props.className, styles.imageUploader)}
         onChange={onFileChange}
        //  renderItem={() => null}
       >
         {props.children}
       </ImageUploader>
      
      
      <div id={_id} style={{ display: "none" }}></div>
    </div>
  );
};
